<template>
  <v-row justify="center">
    <v-col cols="12" sm="10" md="8" lg="6">
      <v-card ref="form" class="busca_avancada_table">
        <v-card-text>
          <v-text-field ref="name" v-model="model.nome_tomador" label="Nome tomador"
            placeholder="Buscar por nome do tomador" required></v-text-field>
          <v-text-field ref="id_apolice" v-model="model.id_apolice" label="Número da apolice" placeholder="Buscar pelo número da apolice" counter="13"
           :rules="[
              () => model.id_apolice.length == 13 || model.id_apolice == '' || 'O número da apolice possui 13 dígitos',
              lengthVerify
            ]"></v-text-field>
            <v-text-field ref="id_proposta" v-model="model.id_proposta" label="Número da proposta"
            placeholder="Buscar por número da proposta" required></v-text-field>
          <v-text-field ref="documento" v-model="model.tomador_documento" label="CPF/CNPJ" :rules="[
              () => model.tomador_documento.length == 11 || model.tomador_documento.length == 14 || model.tomador_documento == '' || 'O documento deve ser um CPF ou CNPJ',
              lengthVerify
            ]" counter="14" placeholder="Buscar por CPF/CNPJ do tomador"></v-text-field>
        </v-card-text>
        <v-divider class="mt-12"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-slide-x-reverse-transition>
            <v-tooltip v-if="formHasErrors" location="left">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="my-0" v-bind="attrs" @click="resetForm" v-on="on">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh form</span>
            </v-tooltip>
          </v-slide-x-reverse-transition>
          <v-btn @click="advancedSearch" class="botao_buscar"
            text>
            Buscar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "Home",
  emits: {},
  data: () => {
    return {
      menu: false,
      formHasErrors: false,
      errorMessages: "",
      filtros: "",
      model: {
        nome_tomador: null,
        id_apolice: null,
        id_proposta: null,
        tomador_documento: null,
        data_emissao__gte: null,
        me: undefined,
      }
    }
  },
  methods: {
    advancedSearch() {
      this.$emit('submit', this.model )
    },
    lengthVerify () {
        this.errorMessages = !this.model.id_apolice && this.model.tomador_documento
          ? `O documento precisa ser um CPF ou CNPJ` 
          : ''
        return true
      },
  }
}

</script>



}


<style lang="scss" scoped>
#jns {
  .text_field {
    padding: 100px;
  }

  .busca_avancada_table {
    margin-top: 30px;

  }

  .botao_buscar {
    width           : 10%;
    height          : 35px;
    border-radius   : 35px;
    background-color: #061d45;
    font-family     : Helvetica;
    font-size       : 1.14rem;
    font-weight     : bold;
    text-align      : center;
    color           : white;
    box-shadow      : 0 0 7px 0 rgba(0, 0, 0, 0.13);
    border          : 1px solid #061d45;
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/BuscaAvancadaApolice.vue